import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { ErrorsService } from '../errors-service/errors.service';

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {
    private _errorsService = inject(ErrorsService);

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: unknown) => {
                if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.TooManyRequests) {
                    void this._errorsService.handleHttpError(error);
                }

                return throwError(() => error);
            }),
        );
    }
}
